import React from 'react';
import './seconday cta long.css'

const SecondaryctaLong = (props) => {
    return ( 
        <button className='long-cta-bg2'>
            <nav className='yellow-cont-bg2'  onClick={props.onClick}>
                <h2 className='cta-text-primary2'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default SecondaryctaLong;